import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import { cn } from "../lib/utils.js";
function TooltipProvider({ delay = 0, closeDelay = 0, ...props }) {
    return (_jsx(BaseTooltip.Provider, { "data-slot": "tooltip-provider", delay: delay, closeDelay: closeDelay, ...props }));
}
function Tooltip({ ...props }) {
    return _jsx(BaseTooltip.Root, { "data-slot": "tooltip", ...props });
}
function TooltipTrigger({ ...props }) {
    return _jsx(BaseTooltip.Trigger, { "data-slot": "tooltip-trigger", ...props });
}
function TooltipPortal({ ...props }) {
    return _jsx(BaseTooltip.Portal, { "data-slot": "tooltip-portal", ...props });
}
function TooltipPositioner({ ...props }) {
    return _jsx(BaseTooltip.Positioner, { "data-slot": "tooltip-positioner", ...props });
}
function TooltipArrow({ ...props }) {
    return _jsx(BaseTooltip.Arrow, { "data-slot": "tooltip-arrow", ...props });
}
function TooltipContent({ className, align = "center", sideOffset = 8, side = "bottom", children, ...props }) {
    return (_jsx(TooltipPortal, { children: _jsx(TooltipPositioner, { className: "z-[60]", sideOffset: sideOffset, align: align, side: side, children: _jsx(BaseTooltip.Popup, { "data-slot": "tooltip-content", className: cn("bg-gray-950 text-gray-50 outline-background/10 z-50 w-fit max-w-75 origin-(--transform-origin) rounded-md px-2.5 py-1.5 text-xs font-medium text-balance shadow-sm outline -outline-offset-1 transition-[transform,scale,opacity] data-ending-style:scale-95 data-ending-style:opacity-0 data-starting-style:scale-95 data-starting-style:opacity-0", className), ...props, children: children }) }) }));
}
export { Tooltip, TooltipTrigger, TooltipContent, TooltipPortal, TooltipPositioner, TooltipArrow, TooltipProvider, };
//# sourceMappingURL=Tooltip.js.map